import { render, staticRenderFns } from "./ProfileGalleries.vue?vue&type=template&id=124221cb&"
import script from "./ProfileGalleries.vue?vue&type=script&lang=js&"
export * from "./ProfileGalleries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports